import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';

const styles = theme => ({
    button: {
        marginRight: theme.spacing(1),
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    }
});

class AnnulerClotureButton extends React.Component {
    render() {
        const { classes, isCancelCloture, onClick } = this.props;

        return (
            <React.Fragment>
                <Button
                    disabled={isCancelCloture}
                    variant="contained"
                    color="secondary"
                    className={classes.button}
                    onClick={onClick}
                >
                    Annuler la clôture
                    {isCancelCloture === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                </Button>
            </React.Fragment>
        );
    }
}

AnnulerClotureButton.propTypes = {
    isCancelCloture: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
};

export default withStyles(styles)(AnnulerClotureButton);